import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import './styles.scss'

import CompanyDownloadAPI from 'api/company/downloadData'
import Nixi1Spinner from 'components/Nixi1Spinner'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import ContainerPage from 'components/common/ContainerPage'
import Button from 'components/forms/Button'

const DownloadDataView = () => {
  const [state, setState] = useState('')
  const [inProgress, setInProgress] = useState(false)

  const onDownload = useCallback(
    async () => {
      try {
        setInProgress(true)
        if (state) setState('')

        const { url } = await CompanyDownloadAPI.downloadData()

        setState(url)
      } catch(error) {
        SaveToastNotification.error({
          text: 'error_download_company_data'
        })
      }

      setInProgress(false)
    }, []
  )

  return (
    <ContainerPage
      title={I18n.t('nav_managements_download_data')}
    >
      <div className='download-data-container-view'>
        <div className='download-data-container'>
          <div className='download-data-container__title'>
            {I18n.t('management_download_company_data_title')}
          </div>

          {
            !state ? (
              <form
                className='download-data-container__form'
                onSubmit={(e) => {
                  e.preventDefault()

                  onDownload()
                }}
              >
                <div className='download-data-container__form-buttons'>
                  <Button
                    label={I18n.t('button_generate_download')}
                    className='download-data-container__form-buttons-save'
                    disabled={state === '' ? inProgress : true}
                    size='large'
                    type='submit'
                  />
                  {
                    inProgress
                      ? (
                        <div className='download-data-container__form-buttons-loading'>
                          <Nixi1Spinner
                            height='2rem' width='2rem'
                          />
                        </div>
                      )
                      : null
                  }
                </div>
                {
                  inProgress
                    ? (
                      <div className='download-data-container__form-footer'>
                        {I18n.t('management_download_company_data_footer')}
                      </div>
                    )
                    : null
                }
              </form>
            ) : null
          }
          {
            state
              ? (
                <div className='download-data-container__form'>
                  <div className='download-data-container__form-download-title'>
                    {I18n.t('management_download_company_download_title')}
                  </div>
                  <div className='download-data-container__message-download'>
                    <a
                      href={state}
                      target='_blank'
                      rel="noopener noreferrer"
                    >
                      {I18n.t('dashboard_download')}
                    </a>
                  </div>
                </div>
              )
              : null
          }
        </div>
      </div>
    </ContainerPage>
  )
}

export default DownloadDataView
